export class IndexedDBStorage {
  constructor(dbName = 'sns-db', storeName = 'sns-store') {
    this.dbName = dbName
    this.storeName = storeName
    this.db = null
  }

  async init() {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.dbName, 1)
      request.onupgradeneeded = (event) => {
        const db = event.target.result
        if (!db.objectStoreNames.contains(this.storeName)) {
          db.createObjectStore(this.storeName)
        }
      }
      request.onsuccess = (event) => {
        this.db = event.target.result
        resolve(this)
      }
      request.onerror = (event) => reject(event.target.error)
    })
  }

  async setItem(key, value) {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction([this.storeName], 'readwrite')
      const store = transaction.objectStore(this.storeName)
      const request = store.put(value, key)
      request.onsuccess = () => resolve(true)
      request.onerror = (event) => reject(event.target.error)
    })
  }

  async getItem(key) {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction([this.storeName], 'readonly')
      const store = transaction.objectStore(this.storeName)
      const request = store.get(key)
      request.onsuccess = () => resolve(request.result ?? null)
      request.onerror = (event) => reject(event.target.error)
    })
  }

  async removeItem(key) {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction([this.storeName], 'readwrite')
      const store = transaction.objectStore(this.storeName)
      const request = store.delete(key)
      request.onsuccess = () => resolve(true)
      request.onerror = (event) => reject(event.target.error)
    })
  }

  async clear() {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction([this.storeName], 'readwrite')
      const store = transaction.objectStore(this.storeName)
      const request = store.clear()
      request.onsuccess = () => resolve(true)
      request.onerror = (event) => reject(event.target.error)
    })
  }
}

// Usage Example
// (async () => {
//   const storage = await new IndexedDBStorage().init();
//   await storage.setItem('key1', 'Hello IndexedDB');
//   console.log(await storage.getItem('key1')); // Output: "Hello IndexedDB"
//   await storage.removeItem('key1');
//   console.log(await storage.getItem('key1')); // Output: null
// })();
